module.exports = __webpack_public_path__ + "static/media/berntHugenholtz.2c2eb907.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/berntHugenholtz.jpg
// module id = 1562
// module chunks = 1